import { Separator } from '@radix-ui/react-separator'
import React, { useState } from 'react'
import { twMerge } from 'tailwind-merge'

import { CozyMenuIcon } from '@/components/icons/cozy-menu-icon'
import { Sheet, SheetContent, SheetTrigger } from '@/components/sheet'

import { MenuCollapsible } from '../sidebar/menu-collapsible'
import { MenuOption } from '../sidebar/menu-option'
import { menuOptions } from '../utils/menu-options'

export function BottomBar({ className }: React.HTMLAttributes<HTMLDivElement>) {
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  function handleSheetClose() {
    setIsSheetOpen(false)
  }

  return (
    <div
      className={twMerge(
        'z-50 flex h-16 w-full justify-evenly border-t border-t-zinc-200 bg-white shadow-[0px_5px_6px_3px] lg:hidden',
        className,
      )}
    >
      {menuOptions
        .slice(0, 4)
        .map(({ label, path, icon, type, items, isDisabled }) => (
          <React.Fragment key={label}>
            {type === 'group' ? (
              <MenuCollapsible icon={icon} label={label} items={items || []} />
            ) : (
              <MenuOption
                path={path}
                icon={icon}
                label={label}
                isDisabled={isDisabled}
              />
            )}
            <Separator
              orientation="horizontal"
              className="bg-monochromatic-500/20 h-px last:hidden"
            />
          </React.Fragment>
        ))}

      <div className="text-monochromatic-300 flex items-center justify-center px-6">
        <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
          <SheetTrigger>
            <CozyMenuIcon />
          </SheetTrigger>

          <SheetContent className="overflow-y-auto shadow-xl">
            {menuOptions.map(
              ({ label, path, icon, type, items, isDisabled }) => (
                <React.Fragment key={label}>
                  {type === 'group' ? (
                    <MenuCollapsible
                      handleSheetClose={handleSheetClose}
                      icon={icon}
                      label={label}
                      items={items || []}
                      isSheetOpen={isSheetOpen}
                    />
                  ) : (
                    <MenuOption
                      handleSheetClose={handleSheetClose}
                      path={path}
                      icon={icon}
                      label={label}
                      isDisabled={isDisabled}
                      isSheetOpen={isSheetOpen}
                    />
                  )}

                  <Separator
                    orientation="horizontal"
                    className="bg-monochromatic-500/20 h-px last:hidden"
                  />
                </React.Fragment>
              ),
            )}
          </SheetContent>
        </Sheet>
      </div>
    </div>
  )
}
